import React from 'react';
import { Modal, Form, Button, Spinner } from 'react-bootstrap';
import { useTranslation } from 'react-i18next';

function ModalShowNewAPICredential({ show, onHide, createdCredential }) {
    const { t } = useTranslation();

    const copyToClipboard = (value) => {
        navigator.clipboard.writeText(value).then(() => {
            
        }).catch((err) => {
            console.error('Failed to copy: ', err);
        });
    };

    return (
        <Modal show={show} onHide={onHide}>
            <Modal.Header closeButton>
                <Modal.Title>{t('Your new REST-API Credentials')}</Modal.Title>
            </Modal.Header>
            <Modal.Body>
                <Form onSubmit={(e) => e.preventDefault()}>
                    <Form.Group className="mb-3">
                        <Form.Label htmlFor="api_client_id">{t('API Client ID')}</Form.Label>
                        <div className="input-group">
                            <Form.Control
                                type="text"
                                id="api_client_id"
                                defaultValue={createdCredential ? createdCredential.api_client_id : ''}
                                readOnly
                            />
                            <span
                                className="input-group-text"
                                onClick={() => copyToClipboard(createdCredential ? createdCredential.api_client_id : '')}
                                style={{ cursor: 'pointer' }}
                            >
                                <i className="fe fe-copy"></i>
                            </span>
                        </div>
                    </Form.Group>
                    <Form.Group className="mb-3">
                    <Form.Label htmlFor="api_client_id">{t('API Client Secret')}</Form.Label>
                        <div className="input-group">
                            <Form.Control
                                type="text"
                                id="api_secret"
                                defaultValue={createdCredential ? createdCredential.api_client_secret : ''}
                                readOnly
                            />
                            <span
                                className="input-group-text"
                                onClick={() => copyToClipboard(createdCredential ? createdCredential.api_client_secret : '')}
                                style={{ cursor: 'pointer' }}
                            >
                                <i className="fe fe-copy"></i>
                            </span>
                        </div>
                    </Form.Group>
                </Form>
                <p className=" text-warning">
                    <strong>{t('Please make sure to save them securely as they cannot be retrieved later.')}</strong>
                </p>
            </Modal.Body>
            <Modal.Footer>
                <Button variant="primary" onClick={onHide} disabled={false}>
                    {t('Ok, I have saved my Credentials')}
                </Button>
            </Modal.Footer>
        </Modal>
    );
}

export default ModalShowNewAPICredential;